import BreadCrumb from "Common/BreadCrumb";
import {
  DualBoxSelect,
  OptionSelect,
  SelectComponent,
} from "Common/Components";
import React from "react";
import { useTranslation } from "react-i18next";
import { usePermissionsAssigned } from "../../hooks/usePermissionsAssigned";
import { getDefaultValueForSelect } from "helpers/functionsHelpers";

export const PermissionsAssigned = () => {
  const { t } = useTranslation();

  const {
    rolesOptions,
    rolSelected,
    menuOptions,
    menuSelected,
    permissionsAssigned,
    permissionsUnassigned,
    setMenuSelected,
    setRolSelected,
    setPermissionsAssigned,
    changePermissionsAssigned,
  } = usePermissionsAssigned();

  return (
    <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
      <BreadCrumb
        title={t("permissions.titleListPage")}
        pageTitle={t("menu.permissions")}
      />
      <div className="card">
        <div className="card-body">
          <div className="w-full justify-around grid grid-cols-1 gap-4 xl:grid-cols-12">
            <div className="col-span-6">
              <SelectComponent
                label={t("permissions.menuLabelSelect")}
                placeholder={t("permissions.menuPlaceholderSelect")}
                id="company"
                value={getDefaultValueForSelect(menuOptions, menuSelected)}
                options={menuOptions}
                onChange={(e: OptionSelect) => {
                  if (e.value === undefined) return;

                  setMenuSelected(e.value);
                }}
              />
            </div>
            <div className="col-span-6">
              <SelectComponent
                label={t("permissions.roleLabelSelect")}
                placeholder={t("permissions.rolePlaceholderSelect")}
                id="company"
                value={getDefaultValueForSelect(rolesOptions, rolSelected)}
                options={rolesOptions}
                onChange={(e: OptionSelect) => {
                  if (e.value === undefined) return;

                  setRolSelected(e.value);
                }}
              />
            </div>
          </div>
          <div className="w-full pt-6">
            <DualBoxSelect
              options={permissionsUnassigned}
              selectedOptions={permissionsAssigned}
              setSelectedOptions={(e: any) => {
                changePermissionsAssigned(e);
              }}
              leftHeader={t("permissions.unasignedPermissionsHeader")}
              rightHeader={t("permissions.assignedPermissionsHeader")}
            ></DualBoxSelect>
          </div>
        </div>
      </div>
    </div>
  );
};
